<template>
    <v-container class="gradient-bg py-6">
      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-card class="pa-4 mb-4 rounded-xl" v-if="filteredConnections.length">
            <p class="text-h6 font-weight-bold mb-4">My Connections</p>
  
            <v-text-field
              v-model="searchText"
              label="Search Connections"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              class="mb-4"
            />
  
            <v-row>
              <v-col cols="12" sm="6" v-for="conn in filteredConnections" :key="conn.uid">
                <v-card
                  class="pa-3 mb-3 rounded-xl hoverable"
                  @click="goToMemberDetails(conn.uid)"
                  style="cursor: pointer;"
                >
                  <v-row align="center">
                    <v-avatar size="60" class="mr-3">
                      <v-img :src="conn.image || defaultImage" />
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold text-body-1">{{ conn.fullName }}</div>
                      <div class="text-caption grey--text">{{ conn.title }}</div>
                    </div>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
          <div v-else-if="!isLoading" class="white--text text-center">No connections found.</div>
        </v-col>
      </v-row>
  
      <v-dialog v-model="showDisconnectDialog" max-width="500">
        <v-card>
          <v-card-title class="text-h5">Confirm Disconnect</v-card-title>
          <v-card-text>
            Are you sure you want to disconnect from {{ user.fullName }}?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="disconnect">Yes</v-btn>
            <v-btn text @click="showDisconnectDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-bottom-navigation app background-color="#3b5d58" grow dark>
      <v-btn icon to="/home"><v-icon>mdi-home</v-icon><p class="tab-label">Home</p></v-btn>
      <v-btn icon to="/search"><v-icon>mdi-magnify</v-icon><p class="tab-label">Search</p></v-btn>
      <v-btn icon to="/explore"><v-icon>mdi-compass-outline</v-icon><p class="tab-label">Explore</p></v-btn>
      <v-btn icon to="/messages"><v-icon>mdi-message-text-outline</v-icon><p class="tab-label">Messages</p></v-btn>
      <v-btn icon to="/groups"><v-icon>mdi-account-group</v-icon><p class="tab-label">Groups</p></v-btn>
      <v-btn icon to="/member-settings"><v-icon>mdi-account</v-icon><p class="tab-label">Profile</p></v-btn>
    </v-bottom-navigation>
    </v-container>
  </template>
  
  <script>
  import { getAuth } from "firebase/auth";
  import { db } from "@/firebase";
  import { doc, getDoc, collection, getDocs } from "firebase/firestore";
  
  export default {
    data() {
      return {
        user: {},
        connections: [],
        searchText: "",
        defaultImage: "https://via.placeholder.com/160",
        showDisconnectDialog: false,
        isLoading: true
      };
    },
    computed: {
      filteredConnections() {
        const search = this.searchText.toLowerCase();
        return this.connections.filter(conn =>
          conn.fullName?.toLowerCase().includes(search) ||
          conn.title?.toLowerCase().includes(search)
        );
      }
    },
    async mounted() {
      await this.fetchUser();
      await this.fetchConnections();
    },
    methods: {
      async fetchUser() {
        try {
          const auth = getAuth();
          const currentUser = auth.currentUser;
          if (!currentUser) return;
          const docSnap = await getDoc(doc(db, "user", currentUser.uid));
          if (docSnap.exists()) {
            this.user = { uid: currentUser.uid, ...docSnap.data() };
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      },
      async fetchConnections() {
        try {
          const auth = getAuth();
          const currentUser = auth.currentUser;
          if (!currentUser) return;
          const connSnap = await getDocs(collection(db, `user/${currentUser.uid}/connections`));
          this.connections = connSnap.docs.map(doc => ({ uid: doc.id, ...doc.data() }));
        } catch (err) {
          console.error("Error fetching connections:", err);
        } finally {
          this.isLoading = false;
        }
      },
      goToMemberDetails(uid) {
        this.$router.push({ name: "MemberDetail", params: { id: uid } });
      },
      disconnect() {
        this.showDisconnectDialog = false;
        console.log("Disconnect logic triggered.");
      }
    }
  };
  </script>
  
  <style scoped>
  .gradient-bg {
    background: linear-gradient(to bottom, #f2c46d, #3b5d58);
    min-height: 100vh;
  }
  .rounded-xl {
    border-radius: 20px;
  }
  </style>
  